export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11578.e946513d.jpg";